import apiService from '../apiService';

const ACTIVITY_URL = 'get_activity_logs'
const activityService = {
    async getActivity(payload) {
        try {
            // const response = await apiService.get(`/${ACTIVITY_URL}/${payload}` );
            const response = await apiService.post(`/${ACTIVITY_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getRecentActivity() {
        try {
            const response = await apiService.get(`/dashboard/recent_activity`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
}

export default activityService;